module.exports = __webpack_public_path__ + "img/bw-logo.254a989c.svg";